import { Fragment, ReactElement } from "react";
import Ad from "@components/Advertisement/Ad";
import LifestyleCard from "@components/ArticleCard/LifestyleCard";
import { BasicCardProps } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

type LifestyleNewsProps = {
  /** Optional className for the component. */
  className?: string;
  /** The props needed for the card. */
  cardProps: BasicCardProps[];
};

/**
 * The component to render the lifestyle news in a grid style.
 */
export default function LifestyleNews({
  className,
  cardProps,
}: LifestyleNewsProps): ReactElement {
  return (
    <div
      data-testid="lifestyle-news-component"
      className={cn(
        "mb-12 grid grid-cols-1 gap-x-6 gap-y-[72px] lg:grid-cols-3",
        className
      )}
    >
      {cardProps?.map((cardProp, index) => {
        return (
          <Fragment key={cardProp.id}>
            {index === 0 ? (
              <div className="h-full">
                <Ad
                  adType="imu2"
                  className="mb-6 py-5 lg:sticky lg:top-[120px] lg:mb-0"
                />
              </div>
            ) : null}

            <LifestyleCard cardProps={cardProp} />
          </Fragment>
        );
      })}
    </div>
  );
}
